import { Component, OnInit } from '@angular/core';

import { AuthTokenService } from '@core/authentication/auth-token.service';
import { IAuthToken } from '@core/authentication/shared/auth-token.model';

@Component({
    selector: 'ndd-user-menu-view-partner',
    template: require('./user-menu-view-partner.component.html'),
})
export class UserMenuViewPartnerComponent implements OnInit {
    public enterprise: string;
    public partner: string;
    public email: string;
    public fullName: string;

    constructor(private authTokenService: AuthTokenService) { }

    public ngOnInit(): void {
        const token: IAuthToken = this.authTokenService.token;

        this.enterprise = token.ent;
        this.partner = token.part;
        this.email = token.eml;
        this.fullName = token.name;
    }
}
